/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EventStatus = {
    InActive: 'InActive',
    Active: 'Active',
    Cancelled: 'Cancelled',
    Done: 'Done'
} as const;
export type EventStatus = typeof EventStatus[keyof typeof EventStatus];


export function instanceOfEventStatus(value: any): boolean {
    for (const key in EventStatus) {
        if (Object.prototype.hasOwnProperty.call(EventStatus, key)) {
            if (EventStatus[key as keyof typeof EventStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventStatusFromJSON(json: any): EventStatus {
    return EventStatusFromJSONTyped(json, false);
}

export function EventStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventStatus {
    return json as EventStatus;
}

export function EventStatusToJSON(value?: EventStatus | null): any {
    return value as any;
}

export function EventStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EventStatus {
    return value as EventStatus;
}

